module.exports = {"411024100":"安陵镇","411024101":"马栏镇","411024102":"柏梁镇","411024103":"陈化店镇","411024104":"望田镇","411024105":"大马镇","411024106":"陶城镇","411024107":"张桥镇","411024108":"彭店镇","411024109":"只乐镇","411024110":"南坞镇","411024111":"马坊镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411024.json
// module id = 1741
// module chunks = 0